import { DEPARTMENTS } from "../assets/data/DepNames";

export const useDepartments = () => {
    return DEPARTMENTS;
}
